import React, { useEffect } from "react"
import { useInView } from 'react-intersection-observer'

const SpHeaderBorderObserver = () => {
  const {ref, inView, entry} = useInView()

  useEffect(() => {
    const header = document.getElementById("spHeader")

    if(entry == undefined) {
        header.setAttribute("style", "opacity:0;")
    } else if(entry !== undefined && entry.boundingClientRect.top > 0) {
      // 表示させない時のヘッダースタイル
      header.setAttribute("style", "opacity:0;transition-duration: 3s;transform: translateY(-1000px);z-index:99;position: absolute!important;cursor: unset;")
    } else {
      // 表示させる時のヘッダースタイル
      header.setAttribute("style", "opacity:1;")
    }
  }, [inView])

  return (
    <>
    <div ref={ref}></div>
    </>
  )
}

export default SpHeaderBorderObserver
